export default __webpack_public_path__ + "static/media/home-page-2.8d72a251.jpg";